import { useQuery, useTRPC } from "@luckymenu/api-client/react";

/** The signed-in person, from `staff.identity.me`. */
export function useMe() {
	const trpc = useTRPC();
	return useQuery(trpc.staff.identity.me.queryOptions());
}
